import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../shared/components/base.component';
import { UrlHelper } from '../../../shared/helpers/UrlHelper';

@Component({
    selector: 'main-menu-component',
    standalone: true,
    imports: [...BaseComponent.BaseImports],
    templateUrl: './main-menu.component.html'
})

export class MainMenuComponent implements BaseComponent, OnInit
{
    public dashboardUrl = UrlHelper.AppBaseUrl;
    public homeUrl = UrlHelper.SiteBaseUrl;

    constructor()
    {
    }

    async ngOnInit()
    {
    }
}
